// Constants
import {
    RESOURCES_FETCH_ERROR,
    RESOURCES_FETCHED,
    RESOURCES_FETCHING,
    RESOURCES_MARKED_AS_STALE,
    RESOURCES_UPDATE_FETCHED_TIME,
    ResourceTypes,
} from './asyncResourceConstants';

// Types
import { AsyncResourceErrorObject } from './reducers/asyncResourceReducerTypes';
import {
    AsyncResourceFetchedAction,
    AsyncResourceFetchErrorAction,
    AsyncResourceFetchingAction,
    AsyncResourceMarkAsStaleAction,
} from './asyncResourceActionsTypes';

export const fetchingAsyncResource = (resourceName: ResourceTypes, ids?: string[]): AsyncResourceFetchingAction => ({
    type: RESOURCES_FETCHING,
    resource: resourceName,
    ids,
});

export const fetchedAsyncResource = (
    resourceName: ResourceTypes,
    ids: string[] | undefined,
    rest?: object,
): AsyncResourceFetchedAction => ({
    type: RESOURCES_FETCHED,
    resource: resourceName,
    ids,
    ...rest,
});

export const updateFetchedTimeAsyncResource = (
    resourceName: ResourceTypes,
    ids: string[] | undefined,
    rest?: object,
): AsyncResourceFetchedAction => ({
    type: RESOURCES_UPDATE_FETCHED_TIME,
    resource: resourceName,
    ids,
    ...rest,
});

export const asyncResourceFetchError = (
    resourceName: ResourceTypes,
    errors: AsyncResourceErrorObject[],
    // FIXME ideally we shouldn't need to send this error if we're already sending the others
    errorTime: number,
    ids?: string[],
    error?: AsyncResourceErrorObject,
): AsyncResourceFetchErrorAction => ({
    type: RESOURCES_FETCH_ERROR,
    resource: resourceName,
    errors,
    error,
    errorTime,
    ids,
});

export const markAsyncResourceAsStale = (
    resourceName: ResourceTypes,
    ids: string[] | undefined,
): AsyncResourceMarkAsStaleAction => ({
    type: RESOURCES_MARKED_AS_STALE,
    resource: resourceName,
    ids,
});
